<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Remove User
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div>
                <p>Are you sure you want to remove this user?</p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="red">
                        Remove
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import { type User } from '~/types/user'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    user?: User
}>()

const toast = useToast()
const loading = ref<boolean>(false)

async function confirm() {
    if (props.user) {
        loading.value = true

        try {
            await $fetch(`/api/settings/users/${props.user.id}`, {
                method: 'DELETE'
            })

            dismiss(true)
        } catch (error: any) {
            toast.add({
                title: 'Could not delete user, please try again later.',
                color: 'red',
                icon: 'i-ph-warning-duotone'
            })
        } finally {
            loading.value = false
        }
    }
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)

    if (reload) {
        emit('reload', true)
    }
}
</script>